export const TextCard = ({ title, text1, text2, img }) => {
  return (
    <div key={title} className="industry_text_content-card">
      <p className="industry_text_content-card-header">{title}</p>
      <div className="industry_text_content-card-section">
        <img src={img} alt="Check" height="24" width="24" loading="eager" />
        <p className="industry_text_content-card-section-text">{text1}</p>
      </div>
      <div className="industry_text_content-card-section">
        <img src={img} alt="Check" height="24" width="24" loading="eager" />
        <p className="industry_text_content-card-section-text">{text2}</p>
      </div>
    </div>
  );
};
